import React from 'react';
import { useToast } from '@common/toast';
import { ShareLinkWithKakaoProps, copyString, shareLinkWithFacebook, shareLinkWithKakao } from '@utils/common';

import classnames from 'classnames/bind';
import styles from './share.module.scss';
const cx = classnames.bind(styles);

// 이미지 비율 1:1
const SnsShare = ({ title, description, btnText, imageUrl, mobileWebUrl, webUrl }: ShareLinkWithKakaoProps) => {
  const Toast = useToast();

  const handleShareKakao = () => {
    shareLinkWithKakao({
      title,
      description,
      btnText,
      imageUrl,
      mobileWebUrl,
      webUrl,
    });
  };

  const handleShareFacebook = () => {
    shareLinkWithFacebook();
  };

  const handleCopy = () => {
    copyString(() =>
      Toast({
        iconType: 'info',
        content: 'URL을 복사했습니다.',
      }),
    );
  };

  return (
    <div className={cx('shareArea')}>
      <a className={cx('btnShare', 'kakao')} role="button" onClick={handleShareKakao}>
        <span className={cx('hidden')}>share kakao</span>
      </a>
      <a className={cx('btnShare', 'facebook')} role="button" onClick={handleShareFacebook}>
        <span className={cx('hidden')}>share facebook</span>
      </a>
      <a className={cx('btnShare', 'url')} role="button" onClick={handleCopy}>
        <span className={cx('hidden')}>share url</span>
      </a>
    </div>
  );
};

export default SnsShare;
